export const GTM_PROVIDER_SUPPORT_ID = 'GTM-53THF5F';
export const GA_CONTAINER_ID = 'G-27YG9F6LGX';
export var GA_PRODUCT;
(function (GA_PRODUCT) {
    GA_PRODUCT["DEFAULT_S4MP"] = "Spotify for Music Providers";
    GA_PRODUCT["PPP"] = "PPP";
    GA_PRODUCT["CATALOG"] = "Catalog";
    GA_PRODUCT["DELIVERIES"] = "Deliveries";
    GA_PRODUCT["UPLOAD"] = "Upload";
})(GA_PRODUCT || (GA_PRODUCT = {}));
//# sourceMappingURL=types.js.map